import {  useState } from 'react';

import { BmsHeader } from '../../components/main-components/app.header';
import { SkewBox } from "../../components/page/skew";
import { AppFooter } from '../../components/main-components/footer';
import { Loader } from '../../components/utilities/loader';
import { AppAlert } from '../../components/utilities/alert';
import { useGlobalMedic } from '../../services/global-medic/gobal-medic.context';
import { DiscussionUnit } from '../../components/global-medic/discussion-unit';
import { GlobalMedicNav } from '../../components/global-medic/global-medic-nav';


function GlobalMedic() {

    const {
        isLoading,
        allDiscussions
    } = useGlobalMedic();


    const [onAlert, setOnAlert] = useState();

    return (
        <div className="global-medic-container">
            <BmsHeader />
            <SkewBox
                title={"GLOBAL MEDIC"}
                background={"/media/global-medic.png"}
            />
            {isLoading && <Loader />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    acceptAction={onAlert.acceptAction}
                    rejectAction={onAlert.rejectAction}
                    close={() => setOnAlert()}
                />
            )}
            
            <GlobalMedicNav active={'disc'} />

            <div className="global-app-body flx-rw c-jt">
                <div className="recent-items">
                    <div className="object-group">
                        <div className="global-item-cap page-caption">Latest Discussion</div>
                        <DiscussionUnit post={allDiscussions[0]} />
                    </div>
                </div>
            </div>

            <AppFooter />
        </div>
    );
}

export default GlobalMedic;